module.exports = __webpack_public_path__ + "static/img/5059_phase_function_Paper_PointsHejduk_Prediction.7bb1ebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5059_phase_function_Paper_PointsHejduk_Prediction.png
// module id = OSYG
// module chunks = 0